// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-view[data-v-0b148c06]{display:flex;flex-direction:column;gap:24px}.profile-view .header[data-v-0b148c06]{display:flex;align-items:center;gap:16px}.profile-view .header button[data-v-0b148c06]{all:unset;cursor:pointer;display:flex;align-items:center;justify-content:center;height:32px;width:32px;border-radius:100%;background:var(--button-btn-ghost,hsla(0,0%,100%,.16))}", ""]);
// Exports
module.exports = exports;
